import { Stack } from "@mui/material";
import { CheckGreen } from "src/assets";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import officina from "src/fonts/officina.woff2";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { SESSION_KEYS, UI_FLOW_PREFERENCES } from "src/consts/session";

const Success = () => {
  const { t } = useTranslation();

  const [getUiFlowPreferences] = useSessionStorage<UI_FLOW_PREFERENCES>(
    SESSION_KEYS.UI_FLOW_PREFERENCES,
  );

  const handleSubmit = () => {
    const uiFlowPreferences = getUiFlowPreferences();

    if (uiFlowPreferences && uiFlowPreferences.callbackUrlSuccess) {
      window.location.href = uiFlowPreferences?.callbackUrlSuccess;
    }
  };

  return (
    <Stack gap={5}>
      <Stack alignItems={"start"}>
        <CheckGreen />
      </Stack>

      <Text
        text={t("page.addEvSuccess.pageTitle")}
        sx={(theme) => ({
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          color: "#317D5B",
          fontFamily: "officina",
          "@font-face": {
            fontFamily: "officina",
            src: `url(${officina}) format("woff2")`,
          },
        })}
      />

      <Text
        text={t("page.addEvSuccess.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
        })}
      />

      <PrimaryButton
        onClick={handleSubmit}
        text={t("page.siteAuthenticationSuccess.nextButton")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "20px",
          maxWidth: { sm: "320px" },
          color: theme.palette.mainFont.primary,
        })}
      />
    </Stack>
  );
};

export default Success;
